import { PayloadSchemas } from '../../types/types'
import { SchemasTable } from '../../tables/schemas-table/SchemasTable'
import { CreateSchemaModal } from '../create-schema-modal/CreateSchemaModal'
import { EmptyState, Mtds, PlusIcon, ScreenHeader } from 'prove-common'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router'

type SchemasScreenContentProps = {
  payloadSchemas: PayloadSchemas
  contractId?: number
  labId: number | undefined
}

export const SchemasScreenContent = ({
  payloadSchemas,
  contractId,
  labId
}: SchemasScreenContentProps) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [isCreateSchemaOpen, setCreateSchemaOpen] = useState(false)

  // If ?create=true is present, open the modal and then remove the param from the URL.
  useEffect(() => {
    if (searchParams.get('create') === 'true') {
      setCreateSchemaOpen(true)
      const next = new URLSearchParams(searchParams)
      next.delete('create')
      setSearchParams(next, { replace: true })
    }
  }, [searchParams, setSearchParams])

  const createSchemaButton = (
    <Mtds.Button
      data-variant='primary'
      onClick={() => setCreateSchemaOpen(true)}
    >
      <PlusIcon />
      Opprett registreringsskjema
    </Mtds.Button>
  )

  return (
    <Mtds.Prose>
      {contractId == null ? (
        <ScreenHeader
          title='Registreringsskjemaer'
          description={
            <p>
              Skjemaer fungerer som maler for hvilken tilleggsinformasjon
              inspektøren må fylle ut om en prøve ved registrering. Disse
              skjemaene er knyttet til de tilhørende analysetypene.
            </p>
          }
          actions={createSchemaButton}
        />
      ) : (
        <Mtds.Flex data-justify='space-between' data-align='center'>
          <Mtds.Heading>Registreringsskjemaer</Mtds.Heading>
          {createSchemaButton}
        </Mtds.Flex>
      )}
      {payloadSchemas.length ? (
        <SchemasTable schemas={payloadSchemas} contractId={contractId} />
      ) : (
        <EmptyState
          title='Ingen registreringsskjemaer'
          description={
            contractId == null
              ? 'Det finnes ingen registreringsskjemaer ennå.'
              : 'Denne kontrakten har ingen registreringsskjemaer ennå.'
          }
        />
      )}
      <CreateSchemaModal
        isOpen={isCreateSchemaOpen}
        setOpen={setCreateSchemaOpen}
        contractId={contractId}
        labId={labId}
      />
    </Mtds.Prose>
  )
}
